import React, { createContext, useContext, useEffect, useState } from 'react';
import './MasterDetailLayout.css';

interface MasterDetailLayoutProps {
  /** Hay panel de detalle abierto: la tabla le cede un tercio del ancho. */
  isOpen: boolean;
  /**
   * Panel ancho (2/3) y tabla estrecha (1/3). Solo para formularios que no
   * caben en un tercio, como el de orden de compra con su editor de líneas.
   */
  wide?: boolean;
  /**
   * Dos columnas a todo el alto de la zona de contenido, a cualquier ancho: la
   * primera es la vista entera (título, buscador y tabla, cada una con su
   * scroll) y la segunda el panel con DetailPanel `drawer`. Para eso el layout
   * tiene que ser el elemento raíz de la vista.
   */
  drawer?: boolean;
  /**
   * Primero la tabla y después el panel, como hijos directos: el grid los
   * coloca por posición y así el panel conserva su `position: sticky`.
   */
  children: React.ReactNode;
}

interface DrawerExpand {
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

// El expandido vive aquí y no en DetailPanel: al pasar de la ficha al
// formulario el panel se desmonta y perdía el estado; el layout no.
const DrawerExpandContext = createContext<DrawerExpand | null>(null);
export const useDrawerExpand = () => useContext(DrawerExpandContext);

export const MasterDetailLayout = ({ isOpen, wide = false, drawer = false, children }: MasterDetailLayoutProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Al cerrar el panel se reinicia, como antes al desmontarse.
  useEffect(() => {
    if (!isOpen) setIsExpanded(false);
  }, [isOpen]);

  return (
    <DrawerExpandContext.Provider value={{ isExpanded, setIsExpanded }}>
      <div className={`master-detail-layout ${isOpen ? 'is-open' : ''} ${isOpen && wide ? 'is-wide' : ''} ${drawer ? 'is-drawer' : ''} ${isOpen && isExpanded ? 'is-expanded' : ''}`}>
        {children}
      </div>
    </DrawerExpandContext.Provider>
  );
};
